export const THRESHOLD_EXACT_MATCH_FACE = 0.99;
export const THRESHOLD_VERY_HIGH_FACE = 0.98;

export const THRESHOLD_MATCH_IMAGE = 0.9;
export const THRESHOLD_VERY_HIGH_IMAGE = 0.83;
